import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import { UiDatePicker, UiInput, UiButton, UiTextArea, UiRSelect, UiToggle, BgLoader } from "../ui";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import chroma from "chroma-js";
import { toast } from "react-toastify";
import { instance } from "../axios";

import { useNavigate, useLocation } from "react-router-dom";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc';
import { MdOutlineDragHandle, MdOutlinePerson } from "react-icons/md";


const DragHandle = sortableHandle(() => <span className="h2 pe-3 mb-0 text-secondary"><MdOutlineDragHandle /></span>);

const SortableItem = sortableElement((value) => {
  return (
    <div className="d-flex align-items-center bg-light p-3 rounded mb-2" style={{zIndex:9999}}>
      <DragHandle />
      <div className="w-100 d-flex" {...value} />
    </div>
  )
});
const SortableContainer = sortableContainer(({ children }) => {
  return <div className="position-relative">{children}</div>;
});
const TaskChecklistModal = NiceModal.create(
  ({ id, action }) => {
    const [state, setState] = useState({
      inputValue: '',
      value: [],
    });
    const modal = useModal();

    const schema = yup.object().shape({
      checklist: yup.array().of(
        yup.object().shape({
          title: yup.string().nullable().required("This is required field").max(250, 'Maximum character limit is 250'),
        })
      ),

    });
    const {
      register,
      handleSubmit,
      control,
      watch,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });


    const deleteEntry = (id) => {
      if (fields) {
        if (fields.length == 1) {
        }
      }
  
      remove(id)
    }
  
    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
      control,
      name: "checklist", 
    });
    const onSortEnd = ({ oldIndex, newIndex }) => {
      move(oldIndex, newIndex)

    };


    const onSubmitHandler = async (data) => {
      SaveCF(data);
    };
    var SaveCF = (e) => {
      setState({ ...state, loader: true });


      instance({
        method: "post",
        url: "/update_task_checklist",
        data: e,
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };




    const fetchData = () => {

      instance
        .get("/get_checklist?id=" + id)
        .then(function (response) {
          if (response.data.status == 'success') {
            setState({ ...state, ...response.data });

            reset({
              checklist: response.data.checklist})
          } else {
            toast(response.data.msg, { type: "error" });
          }


        })
        .catch(function (error) { })
        .then(function () { });

    }



    useEffect(() => {

      fetchData();
    }, []);
    const location = useLocation();
    useEffect(() => {
      if (modal.visible == true) {
        modal.hide();
      }
    }, [location]);



    return (
      <BootstrapModal {...bootstrapDialog(modal)} >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>{action} Checklist</BootstrapModal.Title>
        </BootstrapModal.Header>
        {state.status ? (
          <form id="checklistform" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
            <BootstrapModal.Body>

            
              <SortableContainer onSortEnd={onSortEnd} useDragHandle>
                {fields && fields.length > 0 && fields.map((value, i) => (
                  <SortableItem key={i} index={i}  id={`itmm-${i}`}>
                    <div key={i} className="flex-grow-1">
                      <div className="row">
                        <div className="col">
                          <UiInput
                            placeholder="Checklist Step"
                            type="text"
                            className="mb-0"
                            name={`checklist[${i}].title`}
                            parentClass="mb-2"
                            message={errors.checklist?.[i]?.title?.message}
                            noerror="1"
                            {...register(`checklist.[${i}].title`)}
                          />

                         

                        </div>
                     
                      </div>


                    </div>
                    <div className="d-flex align-items-center">
                      <UiButton className="btn btn-outline-danger ms-3" onClick={() => deleteEntry(i)} title="" icon="delete"></UiButton>
                    </div>
                  </SortableItem>
                ))}


              </SortableContainer>

              <div className="text-center">
                  <UiButton className="btn btn-outline-success" type="button" onClick={() => append()} title="Add Step" icon="add"> </UiButton>
                </div>
              <UiInput type="hidden" name="task_id" value={id} {...register("task_id")} />


            </BootstrapModal.Body>
            <BootstrapModal.Footer>
              <UiButton loading={state["loader"]} title="Save" />
              <a className="btn btn-secondary" onClick={modal.hide}>Cancel</a>
            </BootstrapModal.Footer>
          </form>
        ) : <BgLoader />}
      </BootstrapModal>
    );
  }
);

export default TaskChecklistModal;
